import React, { useState } from "react";
import CalibrationApi from "../../../../api/CalibrationApi";
import { EArmType } from "../../../../Model/Waypoint";
import { getModuleState } from "../../../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import MtiButton from "../../../Buttons/MtiButton";
import SwitchButton from "../../../Buttons/SwitchButton";
import CartesianArmMover from "../../../Common/CartesianArmMover";
import Collapse from "../../../Common/Collapse";
import Disabled from "../../../Controls/Disabled";
import AccordionToggle from "../../../Plate/AccordionToggle";
import "./PsrManualControl.css";

type Prop = {
  psrIdentifier: string;
};

export default function PsrManualControl({ psrIdentifier }: Prop) {
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, psrIdentifier)
  );

  const [isExpand, setIsExpand] = useState(true);

  const psrState = moduleState.psr;

  const isElectromagnetEngaged = psrState?.isElectromagnetEngaged;
  const isPickUpMotorExtended = psrState?.isPickUpMotorExtended;

  const setElectromagnet = (isActivated: boolean) => {
    CalibrationApi.setElectromagnet(psrIdentifier, isActivated);
  };

  return (
    <div className="psr-testing-control">
      <AccordionToggle
        expanded={isExpand}
        onClick={() => setIsExpand(!isExpand)}
      >
        Arm Mover
      </AccordionToggle>
      <Collapse expanded={isExpand}>
        <Disabled disabled={false}>
          <div className="psr-testing-container">
          <div className="psr-testing-border" style={{ width: "100%" }}>
            <CartesianArmMover
              moduleIdentifier={psrIdentifier}
              armType={EArmType.PsrArm}
            />
          </div>
          {(isPickUpMotorExtended != null ||
            isElectromagnetEngaged != null) && (
            <div className="psr-testing-border" style={{ width: "100%" }}>
              <div>
                {isElectromagnetEngaged != null && (
                  <div className="psr-electro-magnet-switch">
                    <span>Electromagnet Controller</span>
                    <SwitchButton
                      withLetter={true}
                      isOn={isElectromagnetEngaged}
                      onToggle={() => setElectromagnet(!isElectromagnetEngaged)}
                    />
                  </div>
                )}
                {isPickUpMotorExtended != null && (
                  <div style={{ display: "flex" }}>
                    <MtiButton
                      colorVariant="alternate"
                      variant="secondary"
                      size="medium"
                      onClick={() =>
                        CalibrationApi.setPickupMotor(psrIdentifier, true)
                      }
                      disabled={isPickUpMotorExtended}
                      style={{
                        minWidth: 40,
                        height: 32,
                        margin: "10px 10px 0px 10px",
                      }}
                    >
                      Extend
                    </MtiButton>
                    <MtiButton
                      colorVariant="alternate"
                      variant="secondary"
                      size="medium"
                      onClick={() =>
                        CalibrationApi.setPickupMotor(psrIdentifier, false)
                      }
                      disabled={!isPickUpMotorExtended}
                      style={{ minWidth: 40, height: 32, marginTop: "10px" }}
                    >
                      Retract
                    </MtiButton>
                  </div>
                )}
              </div>
            </div>
          )}
          </div>
        </Disabled>
      </Collapse>
    </div>
  );
}
